import { config } from "../Environment";

type GetUserRolesResponse = {
    roles: string[];
};

const tryGetUserRoles = async (retryFetch: Function) => {
    const response = await retryFetch(config.API_BASE + "/api/user/profile/roles", {
      method: "GET",
      credentials: "include",
    });
    if (!response.ok) {
      return undefined;
    }
    const data: GetUserRolesResponse = await response.json();
    const roles = data?.roles ?? [];
    return roles;
  };

export {
    tryGetUserRoles
};
